import React, { useState } from 'react';
import OutsideClickObserver from '../OutsideClickObserver';
import { useIntl } from 'react-intl';
import Common from 'helpers/intl-common';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { ButtonIcon } from '@companycam/slab-web';

/**
 * @deprecated Use { Menu } from `@companycam/slab-web` instead
 *
 * https://slab-web.cocam.co/?path=/docs/menu--docs
 */

const CardMenu = ({
  onClose,
  className,
  triggerWrapperClass,
  size,
  triggerIconSize,
  children,
  menuTestId = 'project__item__more-menu',
  triggerTestId = 'project__item__more-menu-trigger',
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const { formatMessage } = useIntl();

  const toggleMenu = (e) => {
    e.stopPropagation();
    setIsOpen(!isOpen);
  };

  const close = () => {
    setIsOpen(false);
  };

  const handleClickOutside = () => {
    close();
    if (onClose) {
      onClose();
    }
  };

  const actionMenu = cx(
    'dropdown dropdown--card show-contents react',
    className,
  );

  const triggerClasses = cx('dropdown-trigger', triggerWrapperClass);

  const menuClasses = cx('dropdown-menu', `dropdown-menu--${size}`, className);

  return (
    <OutsideClickObserver active={isOpen} onClickOutside={handleClickOutside}>
      <div className={actionMenu} data-testid={menuTestId}>
        <div
          className={triggerClasses}
          onClick={toggleMenu}
          data-testid={triggerTestId}
        >
          <ButtonIcon
            size={triggerIconSize}
            iconName="dots-horizontal"
            accessibilityLabel={formatMessage(Common.menu)}
          />
        </div>
        {isOpen ? (
          <div className={menuClasses}>
            {typeof children === 'function'
              ? children({ closeMenu: close })
              : children}
          </div>
        ) : null}
      </div>
    </OutsideClickObserver>
  );
};

CardMenu.defaultProps = {
  size: 'small',
  triggerIconSize: 'tiny',
};

CardMenu.propTypes = {
  onClose: PropTypes.func,
  className: PropTypes.string,
  triggerWrapperClass: PropTypes.string,
  children: PropTypes.any,
  size: PropTypes.string,
  menuTestId: PropTypes.string,
  triggerTestId: PropTypes.string,
  triggerIconSize: PropTypes.string,
};

export default CardMenu;
